'use client';

import React from 'react';


export default function HeroSection() {
  return (
    <section id="inicio" className="relative min-h-screen flex items-center overflow-hidden" style={{ background: 'linear-gradient(160deg, #FFD6E0 0%, #FFC2D4 50%, #F4C2D0 100%)' }}>
      {/* Background decorative elements */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-pink-200/60 to-transparent" />
        <div className="absolute bottom-0 left-0 w-96 h-96 rounded-full bg-pink-100/40 blur-3xl -translate-x-1/2 translate-y-1/2" />
        <div className="absolute top-1/4 right-1/4 w-64 h-64 rounded-full bg-dusty-rose/20 blur-2xl" />
      </div>

      {/* Hero image — right side on desktop, background on mobile */}
      <div className="absolute inset-0 lg:left-1/2 lg:inset-y-0 lg:right-0">
        <img
          src="/assets/images/IMG-20260812-WA0007-1789413807299.jpg"
          alt="Mulher negra em tratamento de beleza no estúdio Mãos Mágicas"
          className="w-full h-full object-cover object-center" />
        
        {/* Mobile overlay */}
        <div className="absolute inset-0 lg:hidden" style={{ background: 'linear-gradient(to bottom, rgba(255,214,224,0.3) 0%, rgba(255,214,224,0.85) 60%, rgba(255,214,224,1) 100%)' }} />
        {/* Desktop overlay on image side */}
        <div className="absolute inset-0 hidden lg:block" style={{ background: 'linear-gradient(to right, #FFD6E0 0%, rgba(255,214,224,0.2) 60%, transparent 100%)' }} />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 w-full pt-24 pb-16 lg:pt-0 lg:pb-0">
        <div className="max-w-xl lg:max-w-2xl">
          {/* Gold accent line */}
          <span className="gold-line mb-6 block" />

          {/* Eyebrow */}
          <p className="text-xs tracking-[0.25em] uppercase font-medium text-burnt-rose mb-4 animate-fade-in">
            Estúdio de Beleza · Maputo
          </p>

          {/* Headline */}
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-light leading-[1.05] text-dark-brown mb-6 animate-slide-up">
            Pele Lisa.
            <br />
            <em className="italic text-burnt-rose">Confiança</em>
            <br />
            em Alta.
          </h1>

          {/* Subheadline */}
          <p className="font-sans text-base lg:text-lg text-foreground/70 leading-relaxed mb-10 max-w-md animate-slide-up" style={{ animationDelay: '0.1s' }}>
            Depilação a cera com cuidado, privacidade e profissionalismo em Maputo.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-3 animate-slide-up" style={{ animationDelay: '0.2s' }}>
            <a
              href="#agendar"
              className="inline-flex items-center justify-center px-8 py-4 btn-primary rounded-full text-sm tracking-[0.12em] uppercase font-semibold">
              
              Agendar Sessão
            </a>
            <a
              href="#servicos"
              className="inline-flex items-center justify-center px-8 py-4 btn-outline rounded-full text-sm tracking-[0.12em] uppercase font-semibold">
              
              Conhecer Serviços
            </a>
          </div>

          {/* Trust signals */}
          <div className="flex items-center gap-6 mt-10 animate-fade-in" style={{ animationDelay: '0.4s' }}>
            <div className="flex items-center gap-2">
              <div className="w-1.5 h-1.5 rounded-full bg-burnt-rose" />
              <span className="text-xs text-foreground/60 tracking-wide">Cera Premium</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-1.5 h-1.5 rounded-full bg-burnt-rose" />
              <span className="text-xs text-foreground/60 tracking-wide">Atendimento Privado</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-1.5 h-1.5 rounded-full bg-burnt-rose" />
              <span className="text-xs text-foreground/60 tracking-wide">Marcação Online</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-fade-in" style={{ animationDelay: '0.8s' }}>
        <span className="text-[10px] tracking-[0.2em] uppercase text-foreground/40">Descobrir</span>
        <div className="w-px h-8 bg-gradient-to-b from-burnt-rose/60 to-transparent" />
      </div>
    </section>);

}